module.exports = __webpack_public_path__ + "static/media/thunderstorm-sun.e3bdfc37.svg";